import { Navigate, useParams } from 'react-router-dom';
import UrunSayfasi from './urun/UrunSayfasi';

/**
 * ÜRÜN KARTI (`/stok/:id`) — ürünün her şeyi tek sayfada, Shopify "Ürün" düzeninde.
 * Sayfanın kendisi `urun/UrunSayfasi.tsx`; yeni ürün (`/stok/yeni`) de aynı düzeni kullanır.
 */
export default function UrunKarti() {
  const { id } = useParams();
  const no = Number(id);
  if (!Number.isInteger(no) || no <= 0) return <Navigate to="/stok" replace />;
  return <UrunSayfasi id={no} key={no} />;
}
